import { IAction, IAppState } from '../../models/action/core';
import { Dispatch } from 'react';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import * as Actions from '../../store/actions/request';
import * as RequestAction from '../constants/core';

const _logger = Log.create('RequestMiddleware');
const _common = new Common();

const setLoginPage = (globalState: any, action: any) => {
    if(action.spinnerId !== "exitfromsimulate"){
        if(window.location.pathname !== '/'){
            if(globalState.login.login.isAlmsPlusLoginPage === false){
                _common.ClearAuthLocalStorage();
                window.location.href = '/';
            }else if(window.location.pathname !== window.appSettings.DEFAULT_URL && window.location.pathname !== window.appSettings.DEFAULT_URL + "/reset-password-form"){
                _common.ClearAuthLocalStorage();
                window.location.href = window.appSettings.DEFAULT_URL;
            }
        } else if(window.location.pathname !== window.appSettings.DEFAULT_URL){
            if(globalState.login.login.isAlmsPlusLoginPage === true ){
                _common.ClearAuthLocalStorage();
                window.location.href = window.appSettings.DEFAULT_URL;
            }
        }
    }        
    
}
let isRedirecting = false;
const RequestMiddleware = (store: any) => {
    return (next: Dispatch<IAction>) => {
        return (action: IAction) => {
            const result = next(action);

            const globalState: IAppState = store.getState();

            const refreshThreshold = new Date();
            const tokens = _common.GetAuthLocalStorage();
            if (window.location.href.indexOf('external-login') === -1 && window.location.href.indexOf('edevlet-login') === -1 && window.location.href.indexOf('verification') === -1 && window.location.href.indexOf('oidc-login') === -1) {
                if (((tokens.auth_url && tokens.auth_url.length > 0) && tokens.auth_url !== window.appSettings.AUTH_URL) || (tokens.access_token && tokens.expire_date && tokens.access_token.length > 0 && tokens.expire_date < refreshThreshold)) {
                    // auth url different redirect
                    _common.ClearAuthLocalStorage();
                    window.location.href = window.appSettings.DEFAULT_URL;
                    return null;
                } else if ((tokens.access_token === '' || tokens.access_token === null) && action.type !== 'LOGIN_LOGOFF' && action.type !== 'ALMS_LOGIN_LOGOUT' && !isRedirecting) {
                    // redirect if opened by link and no token
                    setLoginPage(globalState, action);
                    return null;
                } else if(action.spinnerId === "exitfromsimulate"){
                    isRedirecting = true;
                    _common.ClearAuthLocalStorage();
                    window.location.href = "/User/RemoveSimulation";

                }
                    // refreshThreshold.setHours(refreshThreshold.getHours() + 1);
                    // const isTokenRefreshing = _common.GetRefreshingLocalStorage();
                    // if (isTokenRefreshing === false && action.type !== RequestAction.actions.CORE_REQUEST && tokens.refresh_token && tokens.refresh_token.length > 0 && refreshThreshold > tokens.expire_date!) {
                    //     _common.InsertRefreshingLocalStorage(true);
                    //     store.dispatch(Actions.SetRefreshToken(tokens.refresh_token));
                    // }
                    // return result;
                
            }
        };

    };
};

export default RequestMiddleware;
